import 'react';
import 'prop-types';
import { Link, Button } from 'reaxl';
import { useSelector } from 'react-redux';
import DigitalRetailOverlayCTA from '../DigitalRetailOverlayCTA/DigitalRetailOverlayCTA.js';
import getEnabledCreditApp from '../utilities/getEnabledCreditApp/getEnabledCreditApp.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
function Divider() {
  return /*#__PURE__*/jsx("span", {
    className: "padding-horizontal-1",
    children: "|"
  });
}
function PrequalCTA(_ref) {
  let {
    buttonSize,
    digitalRetailProps,
    enableSACACreditApp,
    enableSDPCreditApp,
    existingDeal,
    handleSACACreditAppClick = () => {},
    placement,
    dealsDuck,
    label,
    hideSeparator,
    suppressPriceCardCTA,
    ...rest
  } = _ref;
  const {
    listing = {}
  } = digitalRetailProps;
  const isStickyHeader = placement === 'sticky-header';
  const isPaymentCard = placement === 'payment-card';
  const dealDetails = useSelector(state => dealsDuck?.selectors?.getTransformedDealDetails(state));
  const ownerCreditApp = useSelector(state => dealsDuck?.selectors?.getCreditAppDealsByOwnerId?.(state, listing?.owner?.id));
  const {
    isSACAEnabled,
    isSDPEnabled
  } = getEnabledCreditApp({
    dealDetails,
    ownerCreditApp,
    existingDeal,
    enableSACACreditApp,
    enableSDPCreditApp
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [isPaymentCard && isSDPEnabled && /*#__PURE__*/jsxs(Fragment, {
      children: [!hideSeparator && !suppressPriceCardCTA && /*#__PURE__*/jsx(Divider, {}), /*#__PURE__*/jsx(DigitalRetailOverlayCTA, {
        ...digitalRetailProps,
        buttonText: label,
        buttonSize: buttonSize,
        uiContext: "paymentCard"
      })]
    }), isPaymentCard && isSACAEnabled && /*#__PURE__*/jsxs(Fragment, {
      children: [!hideSeparator && !suppressPriceCardCTA && /*#__PURE__*/jsx(Divider, {}), /*#__PURE__*/jsx(Link, {
        onClick: handleSACACreditAppClick,
        undecorated: true,
        ...rest,
        children: label
      })]
    }), isStickyHeader && isSDPEnabled && /*#__PURE__*/jsx("div", {
      children: /*#__PURE__*/jsx(DigitalRetailOverlayCTA, {
        ...digitalRetailProps,
        buttonText: label,
        buttonStyle: "secondary",
        buttonSize: buttonSize,
        uiContext: "stickyHeader"
      })
    }), isStickyHeader && isSACAEnabled && /*#__PURE__*/jsx(Button, {
      bsStyle: "secondary",
      bsSize: buttonSize,
      onClick: handleSACACreditAppClick,
      ...rest,
      children: label
    })]
  });
}
export { PrequalCTA as default };
